/*
  Bâan Kumlaï — pochette en lin offerte dès 5 articles. 20/10/2026.
  5 articles au panier tout compris, une seule pochette offerte par commande,
  popup à l'ouverture du panier. Une seconde pochette peut être ACHETÉE depuis le panier.
  Pas de remise Shopify : deux remises automatiques produit ne se cumulent pas et
  celle des packs serait annulée. Le cadeau est une VARIANTE À 0 € gérée par ce script.
  26/10/2026 : les cadeaux du tirage Siam Si (propriété _tirage) ne comptent pas dans les 5 articles.
  29/10/2026 : la pochette payante ne compte plus non plus (commande #1575 : 3 joncs + 2 pochettes
  achetées = pochette offerte). Seuls les joncs et les bagues comptent.
*/
(function () {
  'use strict';

  var SEUIL = 5;
  var ID_CADEAU = 50701658063013;
  var ID_POCHETTE_PAYANTE = 50583859003557;
  var PRIX_POCHETTE = '5,90 €';
  var HANDLE_POCHETTE = 'pochette-cadeau-lin-bracelet';
  var SOUS_TITRE = 'Pour ranger, protéger et offrir vos joncs Kumlaï';
  var CLE_SESSION = 'bk_pochette_popup';
  var CLE_REFUS = 'bk_pochette_refus';

  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_POCHETTE = racine + 'products/' + HANDLE_POCHETTE;
  var SECTIONS = 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer';

  var GABARITS = [
    { tuile: '.bkpf__tuile', nombre: '.bkpf__n', autreBadge: '.bkpf__badge' },
    { tuile: '.bkp__pack', nombre: '.bkp__pack-n', autreBadge: '.bkp__pack-badge' }
  ];

  var occupe = false;
  var cadeauVuAvant = false;
  var file = Promise.resolve();

  function styles() {
    if (document.getElementById('bk-pochette-css')) return;
    var s = document.createElement('style');
    s.id = 'bk-pochette-css';
    s.textContent = [
      '.bkpo{margin:12px 16px 0;padding:12px 14px;border:1px solid rgba(206,173,95,.45);border-radius:10px;background:rgba(206,173,95,.07);font-size:13px;line-height:1.35}',
      '.bkpo__txt{display:flex;align-items:center;gap:8px;color:#5a4a21}',
      '.bkpo__txt strong{color:#8a6d20}',
      '.bkpo__jauge{position:relative;height:6px;margin-top:9px;border-radius:999px;background:rgba(206,173,95,.22);overflow:hidden}',
      '.bkpo__jauge i{position:absolute;top:0;bottom:0;left:0;display:block;border-radius:999px;background:#CEAD5F;transition:width .45s ease}',
      '.bkpo--ok{border-color:#CEAD5F;background:rgba(206,173,95,.16)}',
      '.bkpo--ok .bkpo__jauge i{width:100%}',
      '.bkpo__plus{display:block;width:100%;margin:10px 0 0;padding:8px 10px;border:1px solid rgba(206,173,95,.7);border-radius:7px;background:#fff;color:#8a6d20;font-size:12px;font-weight:600;letter-spacing:.2px;cursor:pointer}',
      '.bkpo__plus:hover{background:rgba(206,173,95,.12)}',
      '.bkpo__plus[disabled]{opacity:.5;cursor:default}',
      '.bkpo-mention{margin:10px 0 0;padding:9px 11px;border-radius:8px;background:rgba(206,173,95,.12);color:#5a4a21;font-size:13px;line-height:1.4}',
      '.bkpo-mention strong{color:#8a6d20}',
      '.bkpo-ligne quantity-input,.bkpo-ligne .cart-item__quantity-wrapper,.bkpo-ligne .quantity{visibility:hidden}',
      '.bkpo-pop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.45)}',
      '.bkpo-pop__boite{max-width:360px;width:100%;background:#fff;border-radius:14px;padding:22px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.25);position:relative}',
      '.bkpo-pop__fermer{position:absolute;top:8px;right:10px;border:0;background:none;font-size:22px;line-height:1;color:#8a8475;cursor:pointer}',
      '.bkpo-pop__titre{margin:0 0 8px;font-size:17px;font-weight:700;color:#3b3325}',
      '.bkpo-pop__txt{margin:0 0 16px;font-size:14px;line-height:1.45;color:#5f5848}',
      '.bkpo-pop__btn{display:block;width:100%;margin:0 0 9px;padding:12px;border:0;border-radius:6px;background:#CEAD5F;color:#fff;font-size:13px;font-weight:600;letter-spacing:.5px;text-transform:uppercase;cursor:pointer;text-decoration:none}',
      '.bkpo-pop__lien{display:block;font-size:13px;color:#8a6d20;text-decoration:underline;cursor:pointer}'
    ].join('');
    document.head.appendChild(s);
  }

  function memo(cle, valeur) {
    try {
      if (valeur === undefined) return !!sessionStorage.getItem(cle);
      sessionStorage.setItem(cle, '1');
    } catch (e) {}
    return false;
  }

  function panier() {
    return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function ligneCadeau(c) {
    for (var i = 0; i < c.items.length; i++) {
      if (c.items[i].variant_id === ID_CADEAU) return c.items[i];
    }
    return null;
  }

  function nbArticles(c) {
    var n = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (it.variant_id === ID_CADEAU) continue;
      if (it.properties && it.properties._tirage) continue; // cadeau du tirage Siam Si
      if (it.variant_id === ID_POCHETTE_PAYANTE || it.handle === HANDLE_POCHETTE) continue; // pochette achetée
      n += it.quantity;
    }
    return n;
  }

  function appliquerSections(sections) {
    if (!sections) return;
    var cibles = {
      'cart-drawer': 'cart-drawer',
      'cart-icon-bubble': '#cart-icon-bubble',
      'main-cart-items': '#main-cart-items',
      'main-cart-footer': '#main-cart-footer'
    };
    Object.keys(cibles).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var cible = document.querySelector(cibles[id]);
      if (!cible) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(cibles[id]);
      if (source) cible.innerHTML = source.innerHTML;
    });
  }

  function ajouterCadeau() {
    occupe = true;
    return fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: ID_CADEAU, quantity: 1, properties: { _cadeau: 'Offerte dès 5 articles' } }], sections: SECTIONS })
    }).then(function (r) { return r.json(); })
      .then(function (d) { appliquerSections(d.sections); })
      .catch(function () {})
      .then(function () { occupe = false; });
  }

  function reglerCadeau(cle, quantite) {
    occupe = true;
    return fetch(racine + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite, sections: SECTIONS })
    }).then(function (r) { return r.json(); })
      .then(function (d) { appliquerSections(d.sections); })
      .catch(function () {})
      .then(function () { occupe = false; });
  }

  // Seconde pochette, celle-là facturée : certaines clientes offrent plusieurs joncs
  // et veulent un écrin par cadeau.
  function ajouterPochettePayante(bouton) {
    if (bouton) { bouton.disabled = true; bouton.textContent = 'Ajout…'; }
    occupe = true;
    return fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: ID_POCHETTE_PAYANTE, quantity: 1 }], sections: SECTIONS })
    }).then(function (r) { return r.json(); })
      .then(function (d) { appliquerSections(d.sections); })
      .catch(function () {})
      .then(function () { occupe = false; return rafraichir(); });
  }

  function barre(n, cadeau) {
    var reste = SEUIL - n;
    var acquis = !!cadeau || n >= SEUIL;
    var texte = acquis
      ? '<strong>Votre pochette Bâan Kumlaï est offerte.</strong>'
      : 'Plus que <strong>' + reste + (reste > 1 ? ' bijoux' : ' bijou') + '</strong> et votre pochette Bâan Kumlaï est offerte.';
    var largeur = Math.min(100, Math.round((n / SEUIL) * 100));
    var seconde = acquis
      ? '<button type="button" class="bkpo__plus" data-bkpo-seconde>+ Ajouter une autre pochette · ' + PRIX_POCHETTE + '</button>'
      : '';
    return '<div class="bkpo' + (acquis ? ' bkpo--ok' : '') + '" data-bkpo>' +
      '<div class="bkpo__txt"><span aria-hidden="true">' + (acquis ? '🎁' : '🎀') + '</span><span>' + texte + '</span></div>' +
      '<div class="bkpo__jauge"><i style="width:' + largeur + '%"></i></div>' + seconde + '</div>';
  }

  function poserBarre(n, cadeau) {
    var html = barre(n, cadeau);
    var tiroir = document.querySelector('cart-drawer');
    var entete = tiroir && tiroir.querySelector('.drawer__header');
    if (entete && !tiroir.classList.contains('is-empty')) {
      var exist = tiroir.querySelector('[data-bkpo]');
      if (exist) exist.outerHTML = html;
      else entete.insertAdjacentHTML('afterend', html);
    }
    var pied = document.querySelector('#main-cart-footer');
    if (pied && document.querySelector('#main-cart-items')) {
      var exist2 = pied.querySelector('[data-bkpo]');
      if (exist2) exist2.outerHTML = html;
      else pied.insertAdjacentHTML('afterbegin', html);
    }
  }

  function mentionFiche() {
    if (location.pathname.indexOf(HANDLE_POCHETTE) === -1) return;

    var titres = document.querySelectorAll('p.product__text');
    for (var i = 0; i < titres.length; i++) {
      if (/nombre impair/i.test(titres[i].textContent)) titres[i].textContent = SOUS_TITRE;
    }

    if (document.querySelector('.bkpo-mention')) return;
    var ancre = document.querySelector('.product__info-container .price, product-info .price, .price');
    if (!ancre) return;
    var bloc = ancre.closest('.price') || ancre;
    var p = document.createElement('p');
    p.className = 'bkpo-mention';
    p.innerHTML = '🎁 <strong>Offerte dès ' + SEUIL + ' bijoux achetés</strong> (joncs ou bagues) — elle s\'ajoute alors toute seule à votre panier.';
    bloc.insertAdjacentElement('afterend', p);
  }

  function marquerLigneCadeau() {
    var liens = document.querySelectorAll('a[href*="pochette-cadeau-lin-offerte"]');
    for (var i = 0; i < liens.length; i++) {
      var ligne = liens[i].closest('.cart-item, tr, .cart-drawer__item');
      if (ligne) ligne.classList.add('bkpo-ligne');
    }
  }

  function badgesTuiles() {
    GABARITS.forEach(function (g) {
      var tuiles = document.querySelectorAll(g.tuile);
      if (!tuiles.length) return;
      for (var i = 0; i < tuiles.length; i++) {
        var t = tuiles[i];
        if (t.querySelector('.bkpo-badge')) continue;
        var n = t.querySelector(g.nombre);
        if (!n) continue;
        var nb = parseInt(n.textContent, 10);
        if (!(nb >= SEUIL)) continue;

        var b = document.createElement('span');
        b.className = 'bkpo-badge';
        b.textContent = 'Pochette offerte';
        t.appendChild(b);

        var autre = t.querySelector(g.autreBadge);
        if (autre) autre.style.top = '-30px';

        if (t.parentElement) t.parentElement.classList.add('bkpo-haut');
      }
    });
  }

  function popup(n) {
    if (document.querySelector('.bkpo-pop')) return;
    var reste = SEUIL - n;
    var d = document.createElement('div');
    d.className = 'bkpo-pop';
    d.innerHTML = '<div class="bkpo-pop__boite" role="dialog" aria-modal="true" aria-label="Pochette cadeau en lin">' +
      '<button class="bkpo-pop__fermer" type="button" aria-label="Fermer">&times;</button>' +
      '<p class="bkpo-pop__titre">Protégez vos joncs</p>' +
      '<p class="bkpo-pop__txt">La pochette en lin Bâan Kumlaï, pour les ranger et les offrir.</p>' +
      '<a class="bkpo-pop__btn" href="' + URL_POCHETTE + '">L\'ajouter pour ' + PRIX_POCHETTE + '</a>' +
      '<span class="bkpo-pop__lien" data-bkpo-fermer>Ajouter ' + reste + (reste > 1 ? ' bijoux' : ' bijou') + ' de plus, elle est offerte</span></div>';
    document.body.appendChild(d);
    memo(CLE_SESSION, 1);
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('.bkpo-pop__fermer') || e.target.closest('[data-bkpo-fermer]')) d.remove();
    });
  }

  function rafraichir() {
    return panier().then(function (c) {
      var cadeau = ligneCadeau(c);
      cadeauVuAvant = !!cadeau;
      poserBarre(nbArticles(c), cadeau);
      badgesTuiles();
      marquerLigneCadeau();
    });
  }

  function _synchroniser(ouvertureTiroir) {
    return panier().then(function (c) {
      var cadeau = ligneCadeau(c);
      var n = nbArticles(c);

      if (cadeauVuAvant && !cadeau && n >= SEUIL) memo(CLE_REFUS, 1);
      cadeauVuAvant = !!cadeau;
      var refus = memo(CLE_REFUS);

      if (n >= SEUIL && !cadeau && !refus) return ajouterCadeau().then(rafraichir);
      if (n < SEUIL && cadeau) return reglerCadeau(cadeau.key, 0).then(rafraichir);
      if (cadeau && cadeau.quantity > 1) return reglerCadeau(cadeau.key, 1).then(rafraichir);

      poserBarre(n, cadeau);
      badgesTuiles();
      marquerLigneCadeau();
      if (ouvertureTiroir && n > 0 && n < SEUIL && !cadeau && !memo(CLE_SESSION)) popup(n);
      return null;
    }).catch(function () {});
  }

  // Une seule synchronisation à la fois : sans cette file, deux évènements panier
  // rapprochés lisaient le même état et la pochette partait en double.
  function synchroniser(ouvertureTiroir) {
    file = file.then(function () { return _synchroniser(ouvertureTiroir); });
    return file;
  }

  function surveiller() {
    var fetchOrigine = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var chemin = typeof url === 'string' ? url : (url && url.url) || '';
      return fetchOrigine.apply(this, arguments).then(function (rep) {
        // Après un ajout, on rend la réponse seulement une fois le cadeau posé : le constructeur
        // de pack (bk-pack.js) part au paiement dès qu'il l'a reçue (commandes #1571, #1577).
        // 2,5 s au plus, pour ne jamais bloquer le passage au paiement.
        if (!occupe && rep.ok && /\/cart\/add/.test(chemin)) {
          return Promise.race([
            synchroniser(false),
            new Promise(function (ok) { setTimeout(ok, 2500); })
          ]).then(function () { return rep; });
        }
        if (!occupe && /\/cart\/(change|update|clear)/.test(chemin)) {
          setTimeout(function () { synchroniser(false); }, 150);
        }
        return rep;
      });
    };

    var tiroir = document.querySelector('cart-drawer');
    if (tiroir) {
      new MutationObserver(function () {
        if (tiroir.classList.contains('active')) setTimeout(function () { synchroniser(true); }, 200);
      }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
    }

    new MutationObserver(function () { badgesTuiles(); marquerLigneCadeau(); mentionFiche(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  function demarrer() {
    styles();
    mentionFiche();
    surveiller();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bkpo-seconde]');
      if (!b) return;
      e.preventDefault();
      ajouterPochettePayante(b);
    });
    synchroniser(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
